import { COUNTRIES } from 'utils/countries';

// filterCountries parameter is a optional one and if it present it will render the countries based on the filterCountries

const getCountryOptions = (
  filterCountres?: string[],
  preferredCountries: string[] = ['NO', 'SE', 'DK'],
) => {
  const preferred = COUNTRIES.filter((country) => preferredCountries.includes(country.value))
    .map((country) => {
      return { value: country.value, label: country.title };
    })
    .sort((a, b) => preferredCountries.indexOf(a.value) - preferredCountries.indexOf(b.value));

  const rest = COUNTRIES.filter((country) => !preferredCountries.includes(country.value)).map(
    (country) => {
      return { value: country.value, label: country.title };
    },
  );

  if (preferred.length > 0 && rest.length > 0) {
    preferred.push({
      value: '',
      label: 'divider',
    });
  }

  let countryOptions = [...preferred, ...rest];

  if (filterCountres) {
    countryOptions = countryOptions.filter((country) => filterCountres.includes(country.value));
  }
  countryOptions = [{ value: '', label: 'selectCountry' }, ...countryOptions];

  return countryOptions;
};

export default getCountryOptions;
